export const ENTITY_CONTACTS_FETCH = 'REGISTER_ENTITY_CONTACTS_FETCH';
export const ENTITY_CONTACTS_ADD = 'REGISTER_ENTITY_CONTACTS_ADD';
export const ENTITY_CONTACTS_UPDATE = 'REGISTER_ENTITY_CONTACTS_UPDATE';
export const ENTITY_CONTACTS_DELETE = 'REGISTER_ENTITY_CONTACTS_DELETE';
